import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'orderById'
})
export class OrderByIdPipe implements PipeTransform {
    transform<T extends { id: number }>(value: T[] ): T[] {
        return value.sort((a, b) => a.id - b.id);
    }
}
